<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      :hideOperate="true"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
      <template v-slot:expand>
        <div style="margin-bottom: 20px">
          <p class="inline-p">
            当前已选择<span style="padding: 0 5px">{{ currentRow.length }}</span
            >条数据
          </p>
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="jumpToImportPage"
            >导入</el-button
          >
          <el-button
            style="margin-left: 10px"
            type="primary"
            @click="batchSendWMS"
            >推送wms</el-button
          >
          <!--            <el-button style="margin-left: 20px" @click="exportList"-->
          <!--              >导出</el-button-->
          <!--            >-->
        </div>
      </template>
    </customize-page>
    <el-dialog
      :close-on-click-modal="false"
      title="创建核注单"
      width="1200px"
      :visible.sync="showMakeHeZhuDirectFormFlag"
    >
      <el-form
        ref="form"
        :model="heZhuForm"
        label-width="110px"
        :rules="rules"
        size="mini"
        :inline="true"
        label-position="right"
      >
        <el-form-item label="清单类型" prop="billType">
          <!-- 0：普通清单，1：集报清单，3：先入区后报关，4：简单加工，5：保税展示交易，6：区内流转，7：区港联动，8:保税电商，9：一纳成品内销默认为0：普通清单 -->
          <el-select v-model="heZhuForm.billType">
            <el-option value="0" label="普通清单"></el-option>
            <el-option value="1" label="集报清单"></el-option>
            <el-option value="3" label="先入区后报关"></el-option>
            <el-option value="4" label="简单加工"></el-option>
            <el-option value="5" label="保税展示交易"></el-option>
            <el-option value="6" label="区内流转"></el-option>
            <el-option value="7" label="区港联动"></el-option>
            <el-option value="8" label="保税电商"></el-option>
            <el-option value="9" label="一纳成品内销"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营企业" prop="bizOpCompanyCode">
          <el-select filterable v-model="heZhuForm.bizOpCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货企业" prop="rcvCompanyCode">
          <el-select filterable v-model="heZhuForm.rcvCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申报企业" prop="dclCompanyCode">
          <el-select filterable v-model="heZhuForm.dclCompanyCode">
            <el-option
              v-for="item in getEECommerce"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="监管方式" prop="tradeMode">
          <el-select filterable v-model="heZhuForm.tradeMode">
            <el-option
              v-for="item in getTradeMode"
              :key="item.value"
              :label="`${item.value}-${item.label}`"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="运输方式" prop="transMode">
          <el-select filterable v-model="heZhuForm.transMode">
            <el-option
              v-for="item in getTransMode"
              :key="item.value"
              :label="`${item.value}-${item.label}`"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="账册号" prop="emsNo">
          <el-input v-model="heZhuForm.emsNo"></el-input>
        </el-form-item>
        <el-form-item label="起运国" prop="startShipCountry">
          <el-input v-model.number="heZhuForm.startShipCountry"></el-input>
        </el-form-item>
        <el-form-item label="关联账册备案号">
          <el-input v-model="heZhuForm.rltEmsNo"></el-input>
        </el-form-item>
        <el-form-item label="关联清单编号">
          <el-input v-model="heZhuForm.rltInvtNo"></el-input>
        </el-form-item>
        <el-table
          :data="purchaseGoods"
          :border="true"
          style="margin-bottom: 10px"
        >
          <el-table-column prop="skuName" label="商品备案名称">
          </el-table-column>
          <el-table-column prop="itemNo" label="商品料号" width="150">
          </el-table-column>
          <el-table-column prop="purchaseQuantity" label="采购数量" width="100">
          </el-table-column>
          <el-table-column
            prop="declareQuantity"
            label="已申报数量"
            width="100"
          >
          </el-table-column>
          <el-table-column
            prop="unDeclareQuantity"
            label="申报数量"
            width="160"
          >
            <template slot-scope="scope">
              <el-input-number
                v-model="scope.row.unDeclareQuantity"
                size="mini"
                controls-position="right"
                :min="0"
                :max="1 * scope.row.unDeclareQuantity"
              />
            </template>
          </el-table-column>
          <el-table-column prop="unitPrice" label="申报单价" width="100">
            <template slot="header">
              单价
              <a style="font-size: 10px; color: #409eff" @click="copyUnitPrice"
                >(复制)</a
              >
            </template>
            <template slot-scope="scope">
              <el-input v-model="scope.row.unitPrice" size="mini" />
            </template>
          </el-table-column>
          <el-table-column prop="currency" label="申报币种" width="100">
            <template slot="header">
              币种
              <a style="font-size: 10px; color: #409eff" @click="copyCurrency"
                >(复制)</a
              >
            </template>
            <template slot-scope="scope">
              <el-input-number
                style="width: 100%"
                v-model.number="scope.row.currency"
                size="mini"
                :controls="false"
                :precision="0"
              />
            </template>
          </el-table-column>
        </el-table>
        <el-form-item>
          <el-button type="primary" @click="createHeZhuOrder">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="80%" title="轨迹日志" :visible.sync="dialogTableVisible">
      <el-table
        :row-class-name="tableRowClassName"
        :data="traceLogData"
        height="380"
      >
        <el-table-column
          property="appName"
          label="应用"
          width="120"
        ></el-table-column>
        <el-table-column
          property="time"
          label="时间"
          width="100"
        ></el-table-column>
        <el-table-column property="content" label="内容">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column
          property="traceLevel"
          label="级别"
          width="60"
        ></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";
import purchaseApi from "@/api/purchase";
import heZhuApi from "@/api/heZhuApi";
import { mapGetters } from "vuex";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    let initParam = this.$store.state.app.sc["purchaseOrder"];
    if (initParam) {
      this.pagination.currentPage = initParam.request.pageIndex;
      this.pagination.pageSize = initParam.request.pageSize;
      this.filterObj = initParam.request.condition;
    }
  },
  computed: {
    ...mapGetters({
      getEECommerce: "getEECommerce",
      getTradeMode: "getTradeMode",
      getTransMode: "getTransMode",
      getCustomerList: "getCustomerList"
    })
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      uploadData: {
        _aid: 401
      },
      dialogTableVisible: false,
      traceLogData: [],
      uploadName: "CPRODUCT_IMG.xlsx",
      loading: false,
      showMakeHeZhuDirectFormFlag: false,
      heZhuForm: {},
      purchaseGoods: [],
      rules: {
        emsNo: [{ required: true, message: "账册号不能为空", trigger: "blur" }],
        billType: [
          { required: true, message: "清单类型不能为空", trigger: "change" }
        ],
        bizOpCompanyCode: [
          { required: true, message: "请选择经营企业", trigger: "change" }
        ],
        rcvCompanyCode: [
          { required: true, message: "请选择收货企业", trigger: "change" }
        ],
        dclCompanyCode: [
          { required: true, message: "请选择申报企业", trigger: "change" }
        ],
        tradeMode: [
          { required: true, message: "请选择监管方式", trigger: "change" }
        ],
        transMode: [
          { required: true, message: "请选择运输方式", trigger: "change" }
        ],
        startShipCountry: [
          { required: true, message: "请输入起运国代码", trigger: "blur" },
          { type: "number", message: "起运国必须为数字", trigger: "blur" }
        ]
      },
      dataList: [],
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left"
        },
        {
          type: "expand",
          render: (h, params) => {
            const row = params.row;
            const shipmentModeMap = {
              1: "空运",
              2: "海运",
              3: "陆运"
            };
            return (
              <div style={{ width: "1000px", paddingLeft: "50px" }}>
                <el-descriptions title="发货信息" column={4} border>
                  <el-descriptions-item label="发货时间">
                    {row.shipmentDate}
                  </el-descriptions-item>
                  <el-descriptions-item label="到货时间">
                    {row.arrivalDate}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货方式">
                    {shipmentModeMap[row.shipmentMode]}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货地区">
                    {row.shippedFrom}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货人">
                    {row.shipperName}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货人电话">
                    {row.shipperPhone}
                  </el-descriptions-item>
                  <el-descriptions-item label="发货人邮箱">
                    {row.shipperEmail}
                  </el-descriptions-item>
                </el-descriptions>
                <el-descriptions title="清关信息" border>
                  <el-descriptions-item label="转出关区">
                    {row.outAreaName}
                  </el-descriptions-item>
                  <el-descriptions-item label="转出关区代码">
                    {row.outAreaCode}
                  </el-descriptions-item>
                  <el-descriptions-item label="提单号">
                    {row.landingBillNo}
                  </el-descriptions-item>
                  <el-descriptions-item label="报关信息">
                    {row.declareDetailList
                      ? JSON.parse(row.declareDetailList).map(item => (
                          <a
                            style={{ color: "blue" }}
                            href={item.url}
                            key={item.url}
                          >
                            {item.url}
                          </a>
                        ))
                      : ""}
                  </el-descriptions-item>
                </el-descriptions>
              </div>
            );
          }
        },
        {
          title: "来源单号",
          key: "originOrderNo",
          width: 200,
          align: "center",
          render: (h, param) => {
            let row = param.row;
            return (
              <a
                style={{ color: "#409EFF", padding: "0 10px" }}
                onClick={this.jumpToDetailPage.bind(this, row)}
              >
                {row.originOrderNo}
              </a>
            );
          }
        },
        {
          title: "入库类型",
          key: "inboundType",
          width: 150,
          align: "center"
        },
        {
          title: "仓库id",
          key: "warehouseId",
          width: 200,
          align: "center"
        },
        {
          title: "货主id",
          key: "customerId",
          width: 200,
          align: "center"
        },
        {
          title: "申报状态",
          width: 200,
          key: "status",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              WAIT_DECLARE: ["info", "待申报"],
              PART_DECLARE: ["warning", "部分申报"],
              DECLARE_SUCCESS: ["success", "全部申报"]
            };
            return (
              <div>
                <el-tag type={tagType[row.status][0]}>
                  {tagType[row.status][1]}
                </el-tag>
              </div>
            );
          }
        },
        {
          title: "推送wms状态",
          width: 200,
          key: "wmsStatus",
          align: "center",
          render: (h, param) => {
            let row = param.row;
            const tagType = {
              INIT: ["info", "待推送"],
              WMS_CREATE_SUCCESS: ["success", "推送仓库成功"],
              ARRIVE_TO_WMS: ["success", "货物到仓"],
              START_TALLY: ["success", "开始理货"],
              TALLY_FINISHED: ["success", "理货完成"],
              WMS_CREATE_EXCEPTION: ["error", "推送仓库异常"],
              WMS_STOCKIN_FINISHED: ["success", "入库完成"],
              CANCELED: ["info", "已取消"]
            };
            return (
              <div>
                <el-tag type={tagType[row.wmsStatus][0]}>
                  {tagType[row.wmsStatus][1]}
                </el-tag>
              </div>
            );
          }
        },
        {
          title: "创建时间",
          width: 200,
          key: "gmtCreate",
          align: "center"
        },
        {
          title: "操作",
          align: "center",
          width: 370,
          render: (h, param) => {
            let row = param.row;
            return (
              <div>
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.jumpToHeZhuPage.bind(this, row)}
                >
                  查看核注清单
                </a>
                {row.status !== "DECLARE_SUCCESS" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.showMakeHeZhuDirectForm.bind(this, row)}
                  >
                    直接生成核注清单
                  </a>
                ) : null}
                {row.status !== "DECLARE_SUCCESS" ? (
                  <a
                    style={{ color: "#409EFF", padding: "0 10px" }}
                    onClick={this.jumpToHeZhuImportPage.bind(this, row)}
                  >
                    导入核注清单
                  </a>
                ) : null}
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.sendWms.bind(this, row)}
                >
                  推送wms
                </a>
                {row.source !== "DOUYIN" && (
                  <a
                    style={{ color: "red", padding: "0 10px" }}
                    onClick={this.delete.bind(this, row)}
                  >
                    删除
                  </a>
                )}
                {row.status === "DECLARE_SUCCESS" &&
                  row.wmsStatus !== "WMS_STOCKIN_FINISHED" && (
                    <a
                      style={{ color: "#409EFF", padding: "0 10px" }}
                      onClick={this.manualFinish.bind(this, row)}
                    >
                      手工入库完成
                    </a>
                  )}
                <a
                  style={{ color: "#409EFF", padding: "0 10px" }}
                  onClick={this.showTracelogDetail.bind(this, row)}
                >
                  轨迹日志
                </a>
              </div>
            );
          }
        }
      ],
      customsDeclareStatus: {
        INIT: "初始化",
        PLATFORM_AUDITING: "待口岸审核",
        PLATFORM_AUDIT_REJECT: "口岸驳回",
        CUSTOMS_AUDITING: "待总署审核",
        CUSTOMS_AUDIT_PASS: "总署审核通过",
        CUSTOMS_AUDIT_REJECT: "总署驳回"
      },
      filterObj: {
        originOrderNo: "",
        warehouseId: "",
        customerId: "",
        status: "",
        wmsStatus: ""
      },
      currentRow: []
    };
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      let traceLevel = row.traceLevel;
      if (traceLevel === "DEBUG") {
        return "debug-row";
      } else if (traceLevel === "WRAN") {
        return "warning-row";
      } else if (traceLevel === "INFO") {
        return "success-row";
      } else {
        return "error-row";
      }
    },
    showTracelogDetail(row) {
      this.traceLogData = [];
      let bizId = row.originOrderNo;
      this.loading = true;
      this.$store
        .dispatch("traceDetail", {
          bizId
        })
        .then(res => {
          this.loading = false;
          this.traceLogData = res.tracelogItems;
          this.dialogTableVisible = true;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    batchSendWMS() {
      if (this.currentRow.length <= 0) {
        this.$message.warning("请勾选需要重试的订单");
        return;
      }
      const promiseArr = [];
      for (let index in this.currentRow) {
        console.log(this.currentRow[index]);
        const wmsStatus = this.currentRow[index].wmsStatus;
        const status = this.currentRow[index].status;
        if (wmsStatus === "INIT" && status == "DECLARE_SUCCESS") {
          promiseArr.push(
            purchaseApi.sendWms({
              customsDeclarePurchaseId: this.currentRow[index].id
            })
          );
        }
      }
      Promise.all(promiseArr).then(() => {
        this.$message.success("推送成功");
        this.fetch();
      });
    },
    copyCurrency() {
      if (this.purchaseGoods[0].currency) {
        this.purchaseGoods.forEach(item => {
          this.$set(item, "currency", this.purchaseGoods[0].currency);
        });
      }
    },
    copyUnitPrice() {
      if (this.purchaseGoods[0].unitPrice) {
        this.purchaseGoods.forEach(item => {
          this.$set(item, "unitPrice", this.purchaseGoods[0].unitPrice);
        });
      }
    },
    createHeZhuOrder() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$confirm("确定要生成核注清单吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            const request = this.buildHeZhuCreateReq();
            if (request.request.items.every(item => item.qty === 0)) {
              this.$message.error("表体申报数量不能全为0");
              this.loading = false;
              return;
            }
            if (request.request.items.some(item => !item.currency)) {
              this.$message.error("表体币制不能为空");
              this.loading = false;
              return;
            }
            this.loading = true;
            heZhuApi.create(request).then(res => {
              if (res.value) {
                this.$message.success("生成核注清单成功");
                this.showMakeHeZhuDirectFormFlag = false;
                this.fetch();
              }
              this.loading = false;
            });
          });
        } else {
          return false;
        }
      });
    },
    buildHeZhuCreateReq() {
      return {
        request: {
          ...this.heZhuForm,
          items: this.purchaseGoods.map(item => {
            return {
              itemNo: item.itemNo ? item.itemNo.trim() : "",
              unitPrice: item.unitPrice ? item.unitPrice.trim() : "",
              currency: item.currency ? item.currency : "",
              qty: item.unDeclareQuantity
            };
          })
        }
      };
    },
    showMakeHeZhuDirectForm(row) {
      if (this.heZhuForm.purchaseId !== row.id) {
        this.heZhuForm.purchaseId = row.id;
        purchaseApi.load({ purchaseId: row.id }).then(res => {
          this.purchaseGoods = res.items;
        });
      }
      this.showMakeHeZhuDirectFormFlag = true;
    },
    jumpToImportPage() {
      this.$router.push({ name: "purchaseOrderImport" });
    },
    jumpToHeZhuImportPage(row) {
      this.$router.push({
        name: "heZhuOrderImport",
        params: { purchaseId: row.id }
      });
    },
    jumpToHeZhuPage(row) {
      this.$router.push({
        name: "purchaseHeZhuOrder",
        params: { purchaseId: row.id }
      });
    },
    manualFinish(row) {
      this.$confirm("确认手动入库完成?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        purchaseApi
          .manualFinish({
            customsDeclarePurchaseId: row.id
          })
          .then(res => {
            this.$message({
              type: "success",
              message: "入库成功!"
            });
            this.fetch();
          });
      });
    },
    sendWms(row) {
      purchaseApi.sendWms({ customsDeclarePurchaseId: row.id }).then(res => {
        if (res.value) {
          this.$message({
            message: "下发wms成功",
            type: "success"
          });
          this.fetch();
        } else {
          this.$message({
            message: "下发wms失败",
            type: "error"
          });
        }
      });
    },
    downloadTemplate() {
      this.$message.error("旧模板原文件暂不可用，请联系管理员补充本地模板");
    },
    jumpToDetailPage(row) {
      this.$router.push({
        name: "purchaseOrderDetail",
        params: { purchaseId: row.id }
      });
    },
    delete(row) {
      this.$confirm("此操作将删除采购单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        purchaseApi
          .delete({
            purchaseId: row.id
          })
          .then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.fetch();
          });
      });
    },
    fetch() {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        let start = filterParams.applyTime[0] + " 00:00:00",
          end = filterParams.applyTime[1] + " 23:59:59";
        filterParams.gmtCreateStart = new Date(start).getTime();
        filterParams.gmtCreateEnd = new Date(end).getTime();
        delete filterParams.applyTime;
      } else {
        delete filterParams.gmtCreateStart;
        delete filterParams.gmtCreateEnd;
      }
      let searchCondition = {
        ...filterParams,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      };
      purchaseApi.list({ request: searchCondition }).then(res => {
        this.dataList = res.items;
        this.pagination.currentPage = res.page.pageIndex;
        this.pagination.pageSize = res.page.pageSize;
        this.pagination.totalCount = res.page.totalCount;
        this.loading = false;
      });
    },
    selectionChange(rows) {
      this.currentRow = rows;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "来源单号",
              model: "originOrderNo",
              type: type.INPUT
            },
            {
              label: "仓库id",
              model: "warehouseId",
              type: type.INPUT
            },
            {
              label: "货主id",
              model: "customerId",
              type: type.SELECT,
              props: {
                data: this.getCustomerList
              }
            },
            {
              label: "申报状态",
              model: "status",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部"
                  },
                  {
                    value: "WAIT_DECLARE",
                    label: "待申报"
                  },
                  {
                    value: "PART_DECLARE",
                    label: "部分申报"
                  },
                  {
                    value: "DECLARE_SUCCESS",
                    label: "全部申报"
                  }
                ]
              }
            },
            {
              label: "wms推送状态",
              model: "wmsStatus",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: "",
                    label: "全部"
                  },
                  {
                    value: "INIT",
                    label: "待推送wms"
                  },
                  {
                    value: "WMS_CREATE_SUCCESS",
                    label: "推送wms成功"
                  },
                  {
                    value: "WMS_CREATE_EXCEPTION",
                    label: "推送wms异常"
                  },
                  {
                    value: "WMS_STOCKIN_FINISHED",
                    label: "入库完成"
                  }
                ]
              }
            },
            {
              label: "入库类型",
              model: "inboundType",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: null,
                    label: "全部"
                  },
                  {
                    value: "一线入区",
                    label: "一线入区"
                  },
                  {
                    value: "二线入区",
                    label: "二线入区"
                  },
                  {
                    value: "二线区间",
                    label: "二线区间"
                  },
                  {
                    value: "区内结转",
                    label: "区内结转"
                  },
                  {
                    value: "区内流转入库",
                    label: "区内流转入库"
                  },
                  {
                    value: "区间流转入库",
                    label: "区间流转入库"
                  },
                  {
                    value: "保税-跨境海外发货",
                    label: "保税-跨境海外发货"
                  },
                  {
                    value: "退货入区",
                    label: "退货入区"
                  }
                ]
              }
            }
          ]
        }
      ];
    },
    // 导出列表
    exportList(data) {
      this.loading = true;
      const filterParams = Object.assign({}, this.getFilterParams());
      if (filterParams.applyTime != null) {
        filterParams.gmtCreateStart = filterParams.applyTime[0];
        filterParams.gmtCreateEnd = filterParams.applyTime[1];
        delete filterParams.applyTime;
      }
      this.exportGoodsReturnOrder({
        request: {
          ...filterParams
          // currentPage: 1,
          // pageSize: 9999
        }
      }).then(res => {
        this.loading = false;
        if (res.value) {
          this.$alert("提交成功", "提示", {
            confirmButtonText: "确定",
            callback: action => {
              this.$router.push({ name: "download" });
            }
          });
        } else {
          this.$message.error("提交失败");
        }
      });
    }
  }
};
</script>

<style>
.avatar-uploader {
  display: inline-block;
}
.inline-p {
  display: inline-block;
}
.inline-p span {
  color: #3399ff;
}
.filter_con.filterUp .filter-form {
  height: auto;
  overflow: visible;
}
.el-table .warning-row {
  background: #fdf5c9;
}

.el-table .debug-row {
  background: #b9f9ba;
}

.el-table .success-row {
  background: #b9f9ba;
}

.el-table .error-row {
  background: #f95c54;
}
.avatar-uploader {
  display: inline-block;
}
</style>
